import React from 'react';
import { COOKIE_ERROR, LOGIN } from 'app/api/redux-route/routes';
import connect from 'app/api/redux-util/connect-enhancer';
import RouteRenderer from './RouteRenderer';
import {
  hasCookieError,
  isLoggedIn,
} from '../../api/redux-bridgesaw/bridgesaw-selectors';
import { isLoggedInToBridge } from '../../api/redux-bridge/session/selectors';
import { isJigsawOnly } from '../../api/redux-watson/watson-config-selectors';
import { isDevOrLocal } from '../../utils/env';
import { isLoggedInToJigsaw } from '../../api/redux-jigsaw/user-info-selectors';

class PrivateRoute extends React.Component {
  componentDidMount() {
    if (
      !this.props.jigsawOnly &&
      this.props.loggedInToJigsaw &&
      !this.props.loggedInToBridge &&
      isDevOrLocal()
    ) {
      alert(
        'This account is is logged into Jigsaw but not Bridge. This might be caused by logging in with a student account that is broken due to an unexpected account merge, logging in with a teacher account that is not rostered to this bridge, or visiting this page while logged in to a normal bookshelf account.\n\nThis message only appears in dev.'
      );
    }
  }

  render() {
    const { loggedIn, cookieError, ...restProps } = this.props;
    return (
      <RouteRenderer
        hasAccess={loggedIn}
        redirectTo={cookieError ? COOKIE_ERROR : LOGIN}
        {...restProps}
      />
    );
  }
}

const mapStateToProps = state => ({
  loggedIn: isLoggedIn(state),
  loggedInToBridge: isLoggedInToBridge(state),
  loggedInToJigsaw: isLoggedInToJigsaw(state),
  jigsawOnly: isJigsawOnly(state),
  cookieError: hasCookieError(state),
});

export default connect(mapStateToProps)(PrivateRoute);
